exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width:978px){.top-spacing{padding-top:10%}}@media (min-width:979px){.top-spacing{padding-top:5%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?-url&minimize!./node_modules/sass-loader/lib/loader.js!./ClientApp/app/app.component.scss
// module id = 152
// module chunks = 6